import { render, staticRenderFns } from "./reset-pass.vue?vue&type=template&id=17901034&scoped=true&"
import script from "./reset-pass.vue?vue&type=script&lang=js&"
export * from "./reset-pass.vue?vue&type=script&lang=js&"
import style0 from "./reset-pass.vue?vue&type=style&index=0&id=17901034&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17901034",
  null
  
)

export default component.exports